export interface Chapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  chapters: Chapter[];
  updatedAt: string;
  createdAt: string;
}

export const categories: string[] = [
  '全部',
  '热血',
  '恋爱',
  '玄幻',
  '搞笑',
  '悬疑',
  '科幻',
  '校园',
  '竞技',
  '日常',
  '历史',
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '伪装学渣',
    author: '木瓜黄',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20style%2C%20two%20high%20school%20students%20sitting%20at%20desk%2C%20warm%20lighting%2C%20clean%20illustration%20with%20soft%20pastel%20colors%2C%20anime%20manga%20cover%20style%2C%20simple%20white%20background%2C%20youth%20romance%20theme&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '分班考后，两位大名鼎鼎的"伪装学渣"被分进了同一个班。贺朝，性格开朗、成绩垫底；谢俞，沉默寡言、同样是年级倒数。两人被迫成为同桌，从互相看不顺眼到逐渐发现彼此的秘密——原来他们都是隐藏实力的学霸。一场关于青春、友情与成长的故事就此展开……',
    categories: ['校园', '恋爱'],
    rating: 9.7,
    views: 1280000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 分班考试', number: 1, updatedAt: '2024-01-15' },
      { id: 2, title: '第2话 新同桌', number: 2, updatedAt: '2024-01-22' },
      { id: 3, title: '第3话 第一次交锋', number: 3, updatedAt: '2024-01-29' },
      { id: 4, title: '第4话 图书馆偶遇', number: 4, updatedAt: '2024-02-05' },
      { id: 5, title: '第5话 校运会', number: 5, updatedAt: '2024-02-12' },
      { id: 6, title: '第6话 雨天的约定', number: 6, updatedAt: '2024-02-19' },
      { id: 7, title: '第7话 暴露', number: 7, updatedAt: '2024-02-26' },
      { id: 8, title: '第8话 真相大白', number: 8, updatedAt: '2024-03-04' },
      { id: 9, title: '第9话 并肩作战', number: 9, updatedAt: '2024-03-11' },
      { id: 10, title: '第10话 期末考试', number: 10, updatedAt: '2024-03-18' },
      { id: 11, title: '第11话 暑假', number: 11, updatedAt: '2024-03-25' },
      { id: 12, title: '第12话 新的开始（完）', number: 12, updatedAt: '2024-04-01' },
    ],
    updatedAt: '2024-04-01',
    createdAt: '2024-01-15',
  },
  {
    id: 2,
    title: '斗罗大陆',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20art%2C%20a%20young%20warrior%20with%20blue%20hair%20holding%20a%20hammer%2C%20epic%20fantasy%20illustration%2C%20dynamic%20pose%2C%20clean%20manga%20cover%20style%2C%20simple%20gradient%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，没有武术，只有武魂。当唐门暗器遇上异界武魂，一代传奇悄然诞生……',
    categories: ['玄幻', '热血'],
    rating: 9.8,
    views: 3560000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 穿越', number: 1, updatedAt: '2023-06-01' },
      { id: 2, title: '第2话 武魂觉醒', number: 2, updatedAt: '2023-06-08' },
      { id: 3, title: '第3话 诺丁学院', number: 3, updatedAt: '2023-06-15' },
      { id: 4, title: '第4话 大师', number: 4, updatedAt: '2023-06-22' },
      { id: 5, title: '第5话 史莱克学院', number: 5, updatedAt: '2023-06-29' },
    ],
    updatedAt: '2024-07-15',
    createdAt: '2023-06-01',
  },
  {
    id: 3,
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20style%2C%20a%20cool%20male%20gamer%20with%20glasses%20holding%20a%20game%20controller%2C%20modern%20anime%20illustration%2C%20clean%20style%2C%20professional%20esports%20vibe%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部驱逐。离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，带着对往昔的回忆和一把未完成的自制银武，开始了重返巅峰之路……',
    categories: ['热血', '竞技'],
    rating: 9.6,
    views: 2890000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 退役', number: 1, updatedAt: '2023-08-10' },
      { id: 2, title: '第2话 第十区', number: 2, updatedAt: '2023-08-17' },
      { id: 3, title: '第3话 千机伞', number: 3, updatedAt: '2023-08-24' },
    ],
    updatedAt: '2024-07-20',
    createdAt: '2023-08-10',
  },
  {
    id: 4,
    title: '天官赐福',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20ancient%20fantasy%20style%2C%20a%20beautiful%20immortal%20in%20white%20robes%20with%20flower%20petals%2C%20ethereal%20elegant%20illustration%2C%20traditional%20Chinese%20aesthetic%2C%20soft%20warm%20tones%2C%20manga%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '八百年前，谢怜是金枝玉叶的太子，风光无限的天之骄子。一朝得道飞升，成为万人供奉的武神。谁知天有不测风云，短短数年便跌落神坛。八百年后，他第三次飞升成仙，却是个倒霉透顶的破烂神。在这段旅程中，他遇到了一个神秘的红衣少年……',
    categories: ['玄幻', '恋爱'],
    rating: 9.9,
    views: 4210000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 第三次飞升', number: 1, updatedAt: '2023-09-01' },
      { id: 2, title: '第2话 与君山', number: 2, updatedAt: '2023-09-08' },
      { id: 3, title: '第3话 红衣少年', number: 3, updatedAt: '2023-09-15' },
      { id: 4, title: '第4话 半月关', number: 4, updatedAt: '2023-09-22' },
    ],
    updatedAt: '2024-07-18',
    createdAt: '2023-09-01',
  },
  {
    id: 5,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20style%2C%20a%20young%20man%20with%20mysterious%20energy%20powers%2C%20modern%20urban%20fantasy%2C%20dynamic%20action%20pose%2C%20clean%20illustration%2C%20manga%20cover%2C%20simple%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '随着父亲失踪、爷爷的坟墓被盗，普通大学生张楚岚平静的校园生活被彻底颠覆。一个神秘少女冯宝宝突然出现，将他带入了一个隐藏在普通人视线之外的"异人"世界。在这个世界里，一场关乎命运与选择的冒险即将展开……',
    categories: ['热血', '玄幻'],
    rating: 9.5,
    views: 2150000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 异人', number: 1, updatedAt: '2023-07-05' },
      { id: 2, title: '第2话 冯宝宝', number: 2, updatedAt: '2023-07-12' },
      { id: 3, title: '第3话 罗天大醮', number: 3, updatedAt: '2023-07-19' },
    ],
    updatedAt: '2024-07-22',
    createdAt: '2023-07-05',
  },
  {
    id: 6,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romance%20fantasy%2C%20a%20cute%20fox%20girl%20with%20red%20hair%20and%20traditional%20Chinese%20dress%2C%20romantic%20atmosphere%2C%20soft%20pink%20tones%2C%20clean%20anime%20illustration%2C%20simple%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死后投胎转世，不记得前世的爱。妖如果痴情的话，就去找狐妖"购买"一项服务——让投胎转世的人回忆起前世的爱……',
    categories: ['恋爱', '玄幻'],
    rating: 9.4,
    views: 1980000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 红线仙', number: 1, updatedAt: '2023-05-20' },
      { id: 2, title: '第2话 续缘任务', number: 2, updatedAt: '2023-05-27' },
      { id: 3, title: '第3话 王权富贵', number: 3, updatedAt: '2023-06-03' },
    ],
    updatedAt: '2024-07-10',
    createdAt: '2023-05-20',
  },
  {
    id: 7,
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20style%2C%20a%20handsome%20man%20in%20black%20robes%20playing%20a%20flute%2C%20dark%20mysterious%20atmosphere%2C%20traditional%20Chinese%20ink%20style%2C%20elegant%20anime%20cover%2C%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '夷陵老祖魏无羡，在射日之征中使温氏覆灭，却因修鬼道被仙门百家忌惮。最终被自己从小一起长大的师弟江澄带人围剿，落得尸骨无存的下场。十三年后，莫玄羽献舍，魏无羡再度归来，与故人蓝忘机重逢，一段尘封的往事即将揭开……',
    categories: ['玄幻', '悬疑'],
    rating: 9.8,
    views: 5340000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 献舍重生', number: 1, updatedAt: '2023-03-01' },
      { id: 2, title: '第2话 大梵山', number: 2, updatedAt: '2023-03-08' },
      { id: 3, title: '第3话 蓝氏听学', number: 3, updatedAt: '2023-03-15' },
      { id: 4, title: '第4话 水行渊', number: 4, updatedAt: '2023-03-22' },
      { id: 5, title: '第5话 温氏之乱', number: 5, updatedAt: '2023-03-29' },
      { id: 6, title: '第6话 射日之征', number: 6, updatedAt: '2023-04-05' },
      { id: 7, title: '第7话 不夜天城', number: 7, updatedAt: '2023-04-12' },
      { id: 8, title: '第8话 真相（完）', number: 8, updatedAt: '2023-04-19' },
    ],
    updatedAt: '2023-04-19',
    createdAt: '2023-03-01',
  },
  {
    id: 8,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20fantasy%2C%20a%20cool%20young%20man%20with%20ancient%20armor%20and%20a%20guardian%20spirit%20behind%20him%2C%20epic%20dynamic%20illustration%2C%20urban%20fantasy%2C%20clean%20manga%20cover%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '镇魂街，是人界通向灵域的一个中转站。每一位镇魂将都有自己的守护灵，负责镇守一方。普通的应届毕业生夏铃，在求职之际误入罗刹街，结识了镇魂将曹焱兵，由此被卷入了灵域的纷争之中……',
    categories: ['热血', '玄幻'],
    rating: 9.3,
    views: 1670000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 罗刹街', number: 1, updatedAt: '2023-04-10' },
      { id: 2, title: '第2话 守护灵', number: 2, updatedAt: '2023-04-17' },
      { id: 3, title: '第3话 王国组织', number: 3, updatedAt: '2023-04-24' },
    ],
    updatedAt: '2024-07-05',
    createdAt: '2023-04-10',
  },
  {
    id: 9,
    title: '快把我哥带走',
    author: '幽灵',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20slice%20of%20life%2C%20a%20brother%20and%20sister%20arguing%20in%20school%20uniforms%2C%20funny%20exaggerated%20expressions%2C%20bright%20warm%20colors%2C%20clean%20cartoon%20style%2C%20simple%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '"快把我哥带走！"这是时秒每天都在心里呐喊的话。她的哥哥时分，简直就是个行走的麻烦制造机——抢她的零食、偷看她的日记、在她的作业本上乱涂乱画……忍无可忍的时秒许下了一个生日愿望：请把哥哥带走！结果愿望竟然成真了……',
    categories: ['搞笑', '校园'],
    rating: 9.2,
    views: 1450000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 我有一个哥哥', number: 1, updatedAt: '2023-02-01' },
      { id: 2, title: '第2话 生日愿望', number: 2, updatedAt: '2023-02-08' },
      { id: 3, title: '第3话 没有哥哥的日子', number: 3, updatedAt: '2023-02-15' },
      { id: 4, title: '第4话 原来如此（完）', number: 4, updatedAt: '2023-02-22' },
    ],
    updatedAt: '2023-02-22',
    createdAt: '2023-02-01',
  },
  {
    id: 10,
    title: '非人哉',
    author: '一汪空气',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20mythology%2C%20cute%20supernatural%20creatures%20in%20modern%20office%20setting%2C%20nine%20tailed%20fox%20girl%20working%20at%20desk%2C%20humorous%20style%2C%20bright%20pastel%20colors%2C%20clean%20illustration%2C%20simple%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '九尾狐九月，一只修炼成精的狐狸，在现代都市里过着普通上班族的生活。她的同事包括龙王三太子敖烈、观音大士、哪吒等各路神仙妖怪。一群非人类在现代社会中发生的各种搞笑日常，让你笑到停不下来！',
    categories: ['搞笑', '日常'],
    rating: 9.5,
    views: 2340000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 上班第一天', number: 1, updatedAt: '2023-10-01' },
      { id: 2, title: '第2话 同事是龙王', number: 2, updatedAt: '2023-10-08' },
      { id: 3, title: '第3话 观音大士的下午茶', number: 3, updatedAt: '2023-10-15' },
    ],
    updatedAt: '2024-07-25',
    createdAt: '2023-10-01',
  },
  {
    id: 11,
    title: '灵笼',
    author: '艺画开天',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci%20fi%20apocalyptic%20style%2C%20a%20soldier%20in%20futuristic%20armor%20standing%20in%20a%20ruined%20city%2C%20dark%20atmospheric%20illustration%2C%20post%20apocalyptic%20theme%2C%20clean%20manga%20cover%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '不久的将来，地球经历了一场毁灭性的灾难。幸存的人类避难于一座悬浮于空中的堡垒——灯塔。在灯塔中，人类必须遵守三大生存法则。然而在严苛的规则之下，人性的光辉与黑暗交织碰撞，一场关于生存与希望的冒险就此展开……',
    categories: ['科幻', '悬疑'],
    rating: 9.6,
    views: 1890000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 灯塔', number: 1, updatedAt: '2023-11-01' },
      { id: 2, title: '第2话 猎荒者', number: 2, updatedAt: '2023-11-08' },
      { id: 3, title: '第3话 地面任务', number: 3, updatedAt: '2023-11-15' },
    ],
    updatedAt: '2024-07-08',
    createdAt: '2023-11-01',
  },
  {
    id: 12,
    title: '大理寺日志',
    author: 'RC',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20mystery%2C%20a%20white%20cat%20wearing%20ancient%20Chinese%20official%20robes%20in%20an%20ancient%20court%2C%20Tang%20dynasty%20style%2C%20clean%20illustration%2C%20warm%20earthy%20tones%2C%20simple%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '唐朝武周时期，大理寺中有一位神秘的少卿——一只会说话的白猫！它和一个从乡下进京求职的陈拾组成了一个奇特的破案搭-档。在繁华的长安城中，各种离奇案件接连发生，一场融合了悬疑与搞笑的盛唐奇谭就此展开……',
    categories: ['悬疑', '搞笑'],
    rating: 9.4,
    views: 1560000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 初入大理寺', number: 1, updatedAt: '2023-12-01' },
      { id: 2, title: '第2话 猫爷少卿', number: 2, updatedAt: '2023-12-08' },
      { id: 3, title: '第3话 长安奇案', number: 3, updatedAt: '2023-12-15' },
    ],
    updatedAt: '2024-07-12',
    createdAt: '2023-12-01',
  },
  {
    id: 13,
    title: '伍六七',
    author: '何小疯',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20comedy%2C%20a%20young%20assassin%20with%20scissors%20as%20weapon%2C%20casual%20street%20style%2C%20humorous%20dynamic%20illustration%2C%20bright%20colors%2C%20clean%20anime%20cover%2C%20simple%20background&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '小鸡岛上住着一个叫伍六七的青年。表面上他是个在路边摆摊的廉价理发师，实际上他还有另一重身份——刺客！虽然他的刺杀任务总是以各种奇葩的方式失败，但他乐观开朗的性格和出人意料的实力，让他在这条搞笑的刺客之路上越走越远……',
    categories: ['热血', '搞笑'],
    rating: 9.7,
    views: 2780000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 最強理发师', number: 1, updatedAt: '2024-02-01' },
      { id: 2, title: '第2话 刺杀任务', number: 2, updatedAt: '2024-02-08' },
      { id: 3, title: '第3话 小鸡岛的秘密', number: 3, updatedAt: '2024-02-15' },
    ],
    updatedAt: '2024-07-28',
    createdAt: '2024-02-01',
  },
  {
    id: 14,
    title: '罗小黑战记',
    author: 'MTJJ',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cute%20cat%20spirit%20style%2C%20a%20little%20black%20cat%20with%20big%20green%20eyes%20in%20a%20forest%2C%20adorable%20warm%20illustration%2C%20simple%20pastel%20colors%2C%20clean%20anime%20style%2C%20soft%20background&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '一只名为罗小黑的黑色小猫，在森林中失去了自己的家园，被迫来到了人类城市。在这个陌生的环境中，它遇到了善良的人类罗小白和其他妖怪伙伴，开始了一段温暖治愈的冒险旅程。充满童趣的画风和温馨的故事，治愈每一个读者的心灵……',
    categories: ['搞笑', '日常'],
    rating: 9.8,
    views: 3210000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 迷路的小猫', number: 1, updatedAt: '2024-03-01' },
      { id: 2, title: '第2话 新家', number: 2, updatedAt: '2024-03-08' },
      { id: 3, title: '第3话 妖怪朋友', number: 3, updatedAt: '2024-03-15' },
    ],
    updatedAt: '2024-07-30',
    createdAt: '2024-03-01',
  },
  {
    id: 15,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20martial%20arts%2C%20a%20lone%20swordsman%20in%20ancient%20Chinese%20desert%20landscape%2C%20rugged%20realistic%20ink%20style%2C%20gritty%20atmosphere%2C%20warm%20earthy%20tones%2C%20clean%20manga%20cover&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '大业三年，隋炀帝杨广以暴政统治天下。民不聊生，江湖上暗流涌动。身手不凡的镖客刀马，带着一个神秘的孩子小七，以"镖人"的身份行走江湖。在一次押镖途中，他被卷入了一场惊天大阴谋。一场硬派武侠传奇就此展开……',
    categories: ['热血', '历史'],
    rating: 9.9,
    views: 1980000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 镖客刀马', number: 1, updatedAt: '2024-04-01' },
      { id: 2, title: '第2话 大漠孤烟', number: 2, updatedAt: '2024-04-08' },
      { id: 3, title: '第3话 知世郎', number: 3, updatedAt: '2024-04-15' },
    ],
    updatedAt: '2024-07-28',
    createdAt: '2024-04-01',
  },
];